import React from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'
import { makeOptions } from '../helper'

const RequiredMark = () => <span className="required-marker" aria-hidden="true"> *</span>

const UDFInfo = (props) => {
  const { disabled, udfs, athlete, changeState, invalidFieldIds = [] } = props
  const hasError = (id) => invalidFieldIds.includes(id)
  
  return (
    <div className="white-text">
      <Row>
      { 
        udfs.map((udf, index) => {
          var UDFvalue = null
          if (athlete && athlete.udfs) {
            athlete.udfs.forEach(oldUDF => {
              if (udf.key === oldUDF.key) {
                UDFvalue = oldUDF.value
              }
            })
          }
          return (
            <Col key={index} sm={4}>
              <FormGroup className={hasError(udf.label) ? "enrolment-invalid-field" : ""}>
                  <ControlLabel>{udf.label}{udf.required ? <RequiredMark /> : null}</ControlLabel>
                  {
                    udf.type.format === 'list' ?
                      <FormControl  className="opaque-grey" name={udf.label} componentClass="select" id={udf.label} disabled={disabled} defaultValue={UDFvalue} onChange={(e) => changeState(udf.label, e.target.value)}>
                        {makeOptions(udf)}
                      </FormControl>
                    :
                    udf.type.format === 'number' ?
                    <FormControl className="opaque-grey" name={udf.label} id={udf.label} placeholder="" disabled={disabled} type="number" min="0" defaultValue={UDFvalue} onChange={(e) => changeState(udf.label, e.target.value)}/>
                    :
                    <FormControl className="opaque-grey" name={udf.label} type="text" id={udf.label} placeholder="" disabled={disabled} defaultValue={UDFvalue} onChange={(e) => changeState(udf.label, e.target.value)}/>
                  }
              </FormGroup>
            </Col>
          )
        })}
      </Row>
  </div>
  )
}

export default UDFInfo
